function Test() {
  return (
    <div className='App'>
      <header className='App-header'>
        <p>test</p>
      </header>
    </div>
  );
}

export default Test;
